import { AccountMembership } from '@mkp/account-membership/models';
import { createActionGroup, props } from '@ngrx/store';

export const userAccountMembershipListActions = createActionGroup({
  source: 'User Account Membership List',
  events: {
    'Create User Account Membership': props<{ accountId: string; userEmail: string }>(),
    'Delete Account Membership': props<{
      accountMembership: AccountMembership;
      isSelfDelete: boolean;
    }>(),
  },
});
